/**
 * Which project crew rows are in force on a day (docs/specs/cloud/staff-register.md). Its own module, with no
 * imports, so the Edge Functions' build of `alert-notices.ts` (tools/dev/copy-edge-shared.mjs) does not pull in the
 * staff register's other rules; `staff.ts` re-exports it.
 */

/** Crew rows in force on `date` (dates inclusive, open ends count), removed rows left out. */
export function crewOnDate<
  C extends {
    readonly start_date: string | null;
    readonly end_date: string | null;
    readonly deleted_at?: string | null;
  },
>(crew: readonly C[], date: string): C[] {
  return crew.filter(
    (c) =>
      (c.deleted_at ?? null) === null &&
      (c.start_date === null || c.start_date <= date) &&
      (c.end_date === null || c.end_date >= date),
  );
}
